



































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { StudentInfoSectionType } from '@/store/modules/entities/recommendation-letter.module';
import { recommendationLetterModule } from '@/store/modules/entities/recommendation-letter.module';
import { studentModule } from '@/store/modules/entities/student.module';

const CHARACTER_LIMITS = {
  TARGET_INSTITUTION: { min: 2, max: 50 },
  RECOMMENDATION_GUIDELINES: { min: 0, max: 1500 },
  ADMISSION_POLICY: { min: 10, max: 1500 },
  ACHIEVEMENTS: { min: 10, max: 1500 },
  MOST_SIGNIFICANT_ACHIEVEMENT: { min: 10, max: 1500 },
  MOTIVATION_LETTER: { min: 0, max: 1500 },
  PERSONALITY_EPISODE: { min: 10, max: 1500 },
  DESIRED_LENGTH: { min: 100, max: 4000 },
};

@Component
export default class GStudentRecordRecommendationLetterStudentInfoStep extends Vue {
  private inputStarted: Record<number, boolean> = {};
  private radioValue = 3;
  private readonly temperatureMap: Record<number, number> = {
    1: 0.2,
    2: 0.8,
    3: 1.0,
    4: 1.3,
    5: 1.8,
  };
  private readonly reverseTemperatureMap = new Map<number, number>([
    [0.2, 1],
    [0.8, 2],
    [1.0, 3],
    [1.3, 4],
    [1.8, 5],
  ]);

  mounted() {
    const currentTemp = this.temperature;
    const closestKey = Array.from(this.reverseTemperatureMap.keys()).reduce((prev, curr) => {
      return Math.abs(curr - currentTemp) < Math.abs(prev - currentTemp) ? curr : prev;
    });
    this.radioValue = this.reverseTemperatureMap.get(closestKey) || 3;
  }

  private handleRadioChange(value: number) {
    const newTemperature = this.temperatureMap[value];
    if (newTemperature !== undefined) {
      recommendationLetterModule.setTemperature(newTemperature);
    }
  }

  get currentStudentInfoSection(): number {
    return recommendationLetterModule.currentStudentInfoSection;
  }

  get currentStudentInfoCompleted(): boolean {
    if (this.currentStudentInfoSection === 2 || this.currentStudentInfoSection === 6) {
      return true;
    }
    if (this.currentStudentInfoSection === 8) {
      const numValue = this.desiredLength;
      const limits = CHARACTER_LIMITS.DESIRED_LENGTH;
      const isLengthValid = numValue >= limits.min && numValue <= limits.max;
      const isTemperatureValid = this.temperature > 0;
      return isLengthValid && isTemperatureValid;
    }
    const sectionKey = this.getSectionKey(this.currentStudentInfoSection);
    const value = this.getFieldValue(sectionKey) || '';
    const limits = CHARACTER_LIMITS[sectionKey as keyof typeof CHARACTER_LIMITS];
    return value.length >= limits.min;
  }

  get student() {
    return studentModule.student;
  }

  get targetInstitution(): string {
    return recommendationLetterModule.targetInstitution;
  }
  set targetInstitution(value: string) {
    recommendationLetterModule.setTargetInstitution(value);
  }

  get recommendationGuidelines(): string {
    return recommendationLetterModule.recommendationGuidelines;
  }
  set recommendationGuidelines(value: string) {
    recommendationLetterModule.setRecommendationGuidelines(value);
  }

  get admissionPolicy(): string {
    return recommendationLetterModule.admissionPolicy;
  }
  set admissionPolicy(value: string) {
    recommendationLetterModule.setAdmissionPolicy(value);
  }

  get achievements(): string {
    return recommendationLetterModule.achievements;
  }
  set achievements(value: string) {
    recommendationLetterModule.setAchievements(value);
  }

  get mostSignificantAchievement(): string {
    return recommendationLetterModule.mostSignificantAchievement;
  }
  set mostSignificantAchievement(value: string) {
    recommendationLetterModule.setMostSignificantAchievement(value);
  }

  get motivationLetter(): string {
    return recommendationLetterModule.motivationLetter;
  }
  set motivationLetter(value: string) {
    recommendationLetterModule.setMotivationLetter(value);
  }

  get personalityEpisode(): string {
    return recommendationLetterModule.personalityEpisode;
  }
  set personalityEpisode(value: string) {
    recommendationLetterModule.setPersonalityEpisode(value);
  }

  get desiredLength(): number {
    return recommendationLetterModule.desiredLength;
  }
  set desiredLength(value: number) {
    recommendationLetterModule.setDesiredLength(value);
  }

  get desiredLengthInput(): string {
    return this.desiredLength.toString();
  }
  set desiredLengthInput(value: string) {
    if (value === '') return;
    const numValue = parseInt(value, 10);
    if (!isNaN(numValue)) {
      this.desiredLength = numValue;
    }
  }

  get temperature(): number {
    return recommendationLetterModule.temperature;
  }
  set temperature(value: number) {
    recommendationLetterModule.setTemperature(value);
  }

  get validationErrors(): Record<string, string> {
    const errors: Record<string, string> = {};
    const sections = [
      { index: 1, key: 'TARGET_INSTITUTION', titleKey: 'STEP_1_TITLE' },
      { index: 2, key: 'RECOMMENDATION_GUIDELINES', titleKey: 'STEP_2_TITLE' },
      { index: 3, key: 'ADMISSION_POLICY', titleKey: 'STEP_3_TITLE' },
      { index: 4, key: 'ACHIEVEMENTS', titleKey: 'STEP_4_TITLE' },
      { index: 5, key: 'MOST_SIGNIFICANT_ACHIEVEMENT', titleKey: 'STEP_5_TITLE' },
      { index: 6, key: 'MOTIVATION_LETTER', titleKey: 'STEP_6_TITLE' },
      { index: 7, key: 'PERSONALITY_EPISODE', titleKey: 'STEP_7_TITLE' },
      { index: 8, key: 'DESIRED_LENGTH', titleKey: 'STEP_8_TITLE' },
    ];
    const sectionsToValidate = sections.filter(section => section.index < this.currentStudentInfoSection || this.inputStarted[section.index]);
    sectionsToValidate.forEach(section => {
      const value = this.getFieldValue(section.key) || '';
      const limits = CHARACTER_LIMITS[section.key as keyof typeof CHARACTER_LIMITS];
      const fieldName = this.$t(`LETTER_OF_RECOMMENDATION_STEPS.${section.titleKey}`);
      if (section.key !== 'MOTIVATION_LETTER' && section.key !== 'DESIRED_LENGTH' && value.length < limits.min) {
        errors[`section_${section.index}`] = this.$t('VALIDATION_ERRORS.MIN_LENGTH', { field: fieldName, min: limits.min }).toString();
      }
    });
    if (this.currentStudentInfoSection > 8 || this.inputStarted[8]) {
      const numValue = this.desiredLength;
      const limits = CHARACTER_LIMITS.DESIRED_LENGTH;
      const fieldName = this.$t('LETTER_OF_RECOMMENDATION_STEPS.STEP_8_TITLE');
      if (isNaN(numValue) || numValue < limits.min || numValue > limits.max) {
        errors['section_8'] = this.$t('VALIDATION_ERRORS.RANGE_LENGTH', { field: fieldName, min: limits.min, max: limits.max }).toString();
      }
    }
    return errors;
  }

  get hasAnyValidationErrors(): boolean {
    return Object.keys(this.validationErrors).length > 0;
  }

  get allStudentInfoSectionsCompleted(): boolean {
    const allSectionsFilled = this.currentStudentInfoSection === StudentInfoSectionType.GenerationPolicy;
    const noValidationErrors = !this.hasAnyValidationErrors;
    return allSectionsFilled && noValidationErrors;
  }

  handleNextStudentInfoSection() {
    this.inputStarted[this.currentStudentInfoSection] = true;
    if (this.currentStudentInfoCompleted && this.currentStudentInfoSection < StudentInfoSectionType.GenerationPolicy) {
      const nextSection = this.currentStudentInfoSection + 1;
      recommendationLetterModule.setCurrentStudentInfoSection(nextSection);
      this.$nextTick(() => {
        window.scrollBy({ top: 400, behavior: 'smooth' });
      });
    }
  }

  async handleNextSection() {
    const hasErrors = Object.keys(this.validationErrors).length > 0;
    if (!hasErrors && this.currentStudentInfoSection === StudentInfoSectionType.GenerationPolicy) {
      try {
        recommendationLetterModule.setLoadingText(this.$t('RECOMMENDATION_LETTER_POLICY_LOADING').toString());
        recommendationLetterModule.setIsBusy(true);
        await recommendationLetterModule.fetchRecommendationLetterPolicies();
        recommendationLetterModule.setCurrentStep(recommendationLetterModule.currentStep + 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (error) {
        return;
      } finally {
        recommendationLetterModule.setIsBusy(false);
        recommendationLetterModule.setLoadingText();
      }
    }
  }

  get characterLimits() {
    return CHARACTER_LIMITS;
  }

  markInputStarted(sectionIndex: number) {
    this.$set(this.inputStarted, sectionIndex, true);
  }

  handleNumberKeypress(event: KeyboardEvent) {
    const key = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    if (!allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }

  getSectionKey(sectionIndex: number): string {
    const sectionMap: Record<number, string> = {
      1: 'TARGET_INSTITUTION',
      2: 'RECOMMENDATION_GUIDELINES',
      3: 'ADMISSION_POLICY',
      4: 'ACHIEVEMENTS',
      5: 'MOST_SIGNIFICANT_ACHIEVEMENT',
      6: 'MOTIVATION_LETTER',
      7: 'PERSONALITY_EPISODE',
      8: 'DESIRED_LENGTH',
    };
    return sectionMap[sectionIndex] || '';
  }

  getFieldValue(sectionKey: string): string {
    switch (sectionKey) {
      case 'TARGET_INSTITUTION':
        return this.targetInstitution;
      case 'RECOMMENDATION_GUIDELINES':
        return this.recommendationGuidelines;
      case 'ADMISSION_POLICY':
        return this.admissionPolicy;
      case 'ACHIEVEMENTS':
        return this.achievements;
      case 'MOST_SIGNIFICANT_ACHIEVEMENT':
        return this.mostSignificantAchievement;
      case 'MOTIVATION_LETTER':
        return this.motivationLetter;
      case 'PERSONALITY_EPISODE':
        return this.personalityEpisode;
      default:
        return '';
    }
  }
}
